import { FC, useState } from "react"
import './proveedor.css'
import { ProveedorTable } from "./ProveedorTable/ProveedorTable"
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { ContratoTable } from "./ContratoTable/ContratoTable";
import { ProveedorTableSimple } from "./ProveedorTable/ProveedorTableSimple";
import { ContratoTableSimple } from "./ContratoTable/ContratoTableSimple";


export const Proveedor:FC<any> = (props):JSX.Element => {

    const { data, dataMASTER, setData, setDataMASTER, simulated, original, comparativa, saveLoading, same, scenarioBase } = props
   
    const [step, setStep] = useState<boolean>(true)

    const [selectedProvider, setSelectedProvider] = useState<any>(undefined)

    const renderStep = () => {
        switch(step) {
            case true:
                return (
                    <TransitionGroup>
                        <CSSTransition
                            key={1}
                            in={step}
                            timeout={225}
                            classNames="messageout-l"
                            unmountOnExit={true}    
                        >
                            {
                                comparativa?
                                    <ProveedorTable
                                        scenarioBase={scenarioBase}
                                        data={data}
                                        dataMASTER={dataMASTER}
                                        setData={setData}
                                        setDataMASTER={setDataMASTER}
                                        step={step}
                                        setStep={setStep}
                                        selectedProvider={selectedProvider}
                                        setSelectedProvider={setSelectedProvider}
                                        simulated={simulated}
                                        original={original}
                                        saveLoading={saveLoading}
                                        same={same}
                                    />
                                :
                                    <ProveedorTableSimple
                                        scenarioBase={scenarioBase}
                                        data={data}
                                        dataMASTER={dataMASTER}
                                        setData={setData}
                                        setDataMASTER={setDataMASTER}
                                        step={step}
                                        setStep={setStep}
                                        selectedProvider={selectedProvider}
                                        setSelectedProvider={setSelectedProvider}
                                        simulated={simulated}
                                        original={original}
                                        saveLoading={saveLoading}
                                        
                                    />
                            }
                            

                        </CSSTransition>

                    </TransitionGroup>
                )
            case false:
                return (
                    <TransitionGroup>
                        <CSSTransition
                        key={2}
                        in={!step}
                        timeout={225}
                        classNames="messageout"
                        unmountOnExit={true}    
                        >
                            {
                                comparativa?
                                    <ContratoTable
                                        scenarioBase={scenarioBase}
                                        data={data}
                                        dataMASTER={dataMASTER}
                                        setData={setData}
                                        setDataMASTER={setDataMASTER}
                                        step={step}
                                        setStep={setStep}
                                        selectedProvider={selectedProvider}
                                        setSelectedProvider={setSelectedProvider}
                                        simulated={simulated}
                                        original={original}
                                        comparativa={comparativa}
                                        saveLoading={saveLoading}
                                        same={same}
                                    />
                                :
                                    <ContratoTableSimple
                                        scenarioBase={scenarioBase}
                                        data={data}
                                        dataMASTER={dataMASTER}
                                        setData={setData}
                                        setDataMASTER={setDataMASTER}
                                        step={step}
                                        setStep={setStep}
                                        selectedProvider={selectedProvider}
                                        setSelectedProvider={setSelectedProvider}
                                        simulated={simulated}
                                        original={original}
                                        comparativa={comparativa}
                                        saveLoading={saveLoading}
                                    />
                            }
                            
                            

                        </CSSTransition>
                    </TransitionGroup>  
                )
        }
    }

    return (
        <div className="proveedor__wrapper">
            <div className="proveedor__container">
            {renderStep()}
            
            </div>
            
        </div>
    )
}